import React from 'react'
import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { useAccountInfo } from '@context/AccountInfoContext/AccountInfoContext.Provider'

import { Body1 } from '@ui/Typography'
import { Modal } from '@ui/v2/Modal'

import { Button } from '../button/Button'

interface CampaignAccountConfirmationModalProps {
  onClose(): void
}

export const CampaignAccountConfirmationModal: React.FC<CampaignAccountConfirmationModalProps> = ({
  onClose,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { accountInfoLimits } = useAccountInfo()

  return (
    <Modal.Action
      title={t('Campaign Account')}
      renderFooter={() => [
        <Button appearance='secondary' onClick={onClose}>
          {t('Not now')}
        </Button>,
        <Button
          appearance='primary'
          onClick={() => {
            onClose()
            navigate(`/dashboard/traders-room/trading-accounts/new?campaign=true`)
          }}
          disabled={accountInfoLimits?.hasReachedMaxTradingAccounts}
        >
          <b>{t('Create Campaign Account')}</b>
        </Button>,
      ]}
      onConfirm={() => {
        onClose()
        navigate(`/dashboard/traders-room/trading-accounts/new?campaign=true`)
      }}
      onClose={onClose}
    >
      <Body1>
        {t(
          'Campaigns.A Campaign Account is linked to a specific campaign and limited to one per user',
          {
            days: 30,
          }
        )}{' '}
        {t('Campaigns.Do you want to create a Campaign Account now')}
      </Body1>
    </Modal.Action>
  )
}
